import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import Card from '../common/Card'
import Input from '../common/Input'
import Button from '../common/Button'

const changePasswordSchema = z
    .object({
        currentPassword: z.string().min(1, 'Current password is required'),
        newPassword: z.string().min(6, 'Password must be at least 6 characters'),
        confirmPassword: z.string().min(1, 'Please confirm your password'),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
        message: "Passwords don't match",
        path: ['confirmPassword'],
    })

const SettingsSecurityForm = ({ onChangePassword, isChanging }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: zodResolver(changePasswordSchema),
    })

    const onSubmit = async (data) => {
        await onChangePassword({
            currentPassword: data.currentPassword,
            newPassword: data.newPassword,
        })
        reset()
    }

    return (
        <Card title="Security" className="lg:col-span-1">
            <div className="space-y-4">
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                    <Input
                        label="Current Password*"
                        type="password"
                        placeholder="Enter current password"
                        showPasswordToggle
                        {...register('currentPassword')}
                        error={errors.currentPassword?.message}
                    />
                    <Input
                        label="New Password*"
                        type="password"
                        placeholder="Enter new password"
                        showPasswordToggle
                        {...register('newPassword')}
                        error={errors.newPassword?.message}
                    />
                    <Input
                        label="Confirm New Password*"
                        type="password"
                        placeholder="Confirm new password"
                        showPasswordToggle
                        {...register('confirmPassword')}
                        error={errors.confirmPassword?.message}
                    />
                    <Button type="submit" icon="mdi:lock" disabled={isChanging} className="w-full">
                        {isChanging ? 'Changing Password...' : 'Change Password'}
                    </Button>
                </form>
            </div>
        </Card>
    )
}

export default SettingsSecurityForm
